<template>
  <div>
    <el-row type="flex" justify="space-between" gutter=10>
      <el-col :span="1" class="status-spot">
        <el-tooltip class="item" effect="dark" :content="$t('networkstatus')" placement="bottom-start" v-if="$route.name === 'dashboard'">
            <i :class="{
              'el-icon-success text-success': isMqttConnected,
              'el-icon-error text-danger': !isMqttConnected
            }"></i>
        </el-tooltip>
      </el-col>
      <el-col :span="22" class="logo">
        <img
          src="../assets/logo-128x128.png"
          alt
          srcset="../assets/logo-128x128.png 4x, ../assets/logo-32x32.png 1x"
        >
        <span>cloud</span>
      </el-col>
      <el-col :span="0.5" class="language-menu text-primary">
        <div>
          <dropdown class="my-dropdown-toggle" :options="arrayOfObjects" :selected="object" v-on:updateOption="methodToRunOnSelect">
          </dropdown>
        </div>
      </el-col>
      <el-col :span="0.5" class="logo text-primary">
        <div class="position-absolute top-0 start-0">
          <el-tooltip class="item" effect="dark" :content="$t('logout')" placement="bottom-start" v-if="$route.name === 'dashboard'">
            <i @click="logout()" class="ion-md-log-out"></i>
          </el-tooltip>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import dropdown from 'vue-dropdowns';
import { UserStore, MqttStore } from "@/store";
import VueI18n from "../i18n"
export default {
  data() {
    return {
      arrayOfObjects: [{name: "Polski", id: "pl"}, {name: "English", id: "en"}, {name: "Deutsch", id: "de"}],
      object: {
        name: 'English',
      }
    }
  },
  components: {
      'dropdown': dropdown,
  },
  store: { user: UserStore, mqtt: MqttStore },
  computed: {
    isMqttConnected() {
      return this.$store.mqtt.state.cli && this.$store.mqtt.state.cli.connected;
    }
  },
  methods: {
    logout() {
      this.$store.user.dispatch("logout").then(() => this.$router.push("login"));
    },
    methodToRunOnSelect(payload) {
      this.object = payload;
      VueI18n.locale = payload.id;
      VueI18n.fallbackLocale = payload.id;
    }
  }
};
</script>


<style lang="scss">
.logout-spot, .status-spot {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 1.4rem;
}

.status-spot {
  justify-content: flex-start;
}
</style>
